import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { STORAGE_KEYS } from '../constants';
import PawLoader from './PawLoader';

const ProtectedRoute = ({ children }) => {
  const { isAuthenticated, isLoading } = useAuth();

  const hasStoredAuth =
    typeof window !== 'undefined' &&
    localStorage.getItem(STORAGE_KEYS.AUTH) === 'true' &&
    localStorage.getItem(STORAGE_KEYS.USER);
  const consideredAuthenticated = isAuthenticated || hasStoredAuth;

  // Show loading spinner while checking authentication
  if (isLoading && !hasStoredAuth) {
    return <PawLoader fullPage size="lg" />;
  }

  // Redirect to login if not authenticated
  if (!consideredAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  // Render protected content
  return children;
};

export default ProtectedRoute;











